import React from "react";
import Joi from "@hapi/joi";
import Form from "../common/form";
import { withSnackbar } from "notistack";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
/* import { format, formatDistanceToNow } from 'date-fns'
import { es } from 'date-fns/locale' */
import {
  Stepper,
  Step,
  StepButton,
  Button,
  Typography,
} from "@material-ui/core";
import {
  getProject,
  saveProject,
  updateProject_isOpenField,
} from "../../services/projectService";
import { getProjectTypes } from "../../services/projectTypeService";
import { getResearchTypes } from "../../services/researchTypeService";
import { getCoverageTypes } from "../../services/coverageTypeService";
import { getPrograms } from "../../services/programService";
import { getSectors } from "../../services/sectorService";
import { messages } from "../common/es_ES";
import SaveIcon from "@material-ui/icons/Save";
import TitleComponent from "../common/titleComponent";
// import Fab from '@material-ui/core/Fab';
// import NavigationIcon from '@material-ui/icons/Navigation';
import "./project.scss";
import Loading from "../common/loading";
import { Paper } from "@material-ui/core";
import SwitchLabel from "./status/switchLabel";
import { getDependenciesByType } from "../../services/dependencyTypeService";
import { DEPENDENCIES_BY_TYPE } from "../../utils/constants";
import { getLines } from "../../services/lineService";
import { getPatents } from "../../services/PatentsService";
import { getCopyright } from "../../services/CopyrightService";
import { getGroups } from "../../services/ProjectGroupService";
import { getComites } from "../../services/comiteService";
//import { getCopyrights } from '../../services/CopyrightsService';

class ProjectForm extends Form {
  state = {
    data: {
      is_open: false,
      name: "",
      slug: "",
      code: "",
      kind: "",
      dependencies: [],
      careers: [],
      startDate: "",
      endDate: "",
      endDateReal: "",
      lines: [],
      year: "",
      sponsor: "",
      location: "",
      project_type_id: "",
      research_type_id: "",
      coverage_type_id: "",
      groups: [],
      programs: [],
      comites: [],
      sectors: [],

      summary: "",
      background: "",
      justification: "",
      current_situation: "",
      general_objective: "",
      specific_objectives: "",
      sustainability: "",
      methodology: "",
      expected_results: "",
      transference_results: "",
      beneficiaries: "",
      distinctive_signs: "",
      patents_id: "",
      denomination_origin: "",
      register_powers: "",
      companies_without_documents: "",
      copyright_id: "",
      senadi: "",
      id: "",
    },
    projectTypes: [],
    researchTypes: [],
    coverageTypes: [],
    patents: [],
    copyright: [],
    programs: [],
    comites: [],
    lines: [],
    dependencies: [],
    careers: [],
    groups: [],
    sectors: [],
    errors: {},
    isLoading: false,

    activeStep: 0,
    completed: {},
  };

  getSteps = () => {
    return ["Inf. General", "Inf. Adicional"];
  };

  getStepContent = (step) => {
    const {
      projectTypes,
      researchTypes,
      coverageTypes,
      patents,
      copyright,
      programs,
      comites,
      sectors,
      lines,
      dependencies,
      careers,
      groups,
    } = this.state;
    const kinds = [
      { id: 1, name: "Institucional" },
      { id: 2, name: "Facultad" },
      { id: 3, name: "Sede" },
    ];
    switch (step) {
      case 0:
        return (
          <React.Fragment>
            <SwitchLabel
              //openLabel='Abierto'
              openLabel="En Ejecución"
              closeLabel="Cerrado"
              checked={this.state.data.is_open}
              onChangeSwitch={this.handleChangeSwitch}
            />
            {this.renderTextarea("name", "Nombre *")}
            {this.renderTextarea("code", "Código IDI ")}
            {this.renderRadio("kind", "Tipo:", kinds)}

            {this.renderMultiSelect(
              "dependencies",
              "Dependencia/Facultad/Sede *",
              "id",
              "name",
              dependencies
            )}
            {this.renderMultiSelect(
              "careers",
              "Carreras",
              "id",
              "name",
              careers
            )}

            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              {this.renderDatePicker(
                "startDate",
                "Fecha Inicio *",
                "2018-01-01",
                "2025-12-31",
                false
              )}
              {this.renderDatePicker(
                "endDate",
                "Fecha Fin *",
                "2018-02-01",
                "2025-12-31",
                false
              )}

              {this.renderDatePicker(
                "endDateReal",
                "Fecha Fin - Prórroga",
                "2018-02-01",
                "2025-12-31",
                false
              )}
            </MuiPickersUtilsProvider>
            {this.renderMultiSelect(
              "comites",
              "Comite *",
              "id",
              "name",
              comites
            )}
            {this.renderMultiSelect("groups", "Grupos *", "id", "name", groups)}

            {this.renderMultiSelect(
              "lines",
              "Líneas de investigación",
              "id",
              "name",
              lines
            )}

            {this.renderMultiSelect(
              "programs",
              "Programas",
              "id",
              "name",
              programs
            )}

            {this.renderInput("sponsor", "Contraparte")}

            {this.renderSelect(
              "project_type_id",
              "Tipo proyecto *",
              110,
              "id",
              "name",
              projectTypes
            )}

            {this.renderSelect(
              "research_type_id",
              "Tipo investigación *",
              145,
              "id",
              "name",
              researchTypes
            )}

            {this.renderSelect(
              "coverage_type_id",
              "Cobertura *",
              85,
              "id",
              "name",
              coverageTypes
            )}
            {this.renderInput("location", "Ubicación *")}

            {this.renderMultiSelect(
              "sectors",
              "Impactos *",
              "id",
              "name",
              sectors
            )}
            <h4 style={{ color: "white" }}> HOLA </h4>
          </React.Fragment>
        );
      case 1:
        return (
          <React.Fragment>
            {this.renderTextarea("name", "Nombre")}
            {this.renderTextarea("summary", "Resumen")}
            {this.renderTextarea("background", "Antecedentes")}
            {this.renderTextarea("justification", "Justificación")}
            {this.renderTextarea(
              "current_situation",
              "Análisis situación actual"
            )}
            {this.renderTextarea("general_objective", "Objetivo general")}
            {this.renderTextarea(
              "specific_objectives",
              "Objetivos específicos"
            )}
            {this.renderTextarea("sustainability", "Sostenibilidad")}
            {this.renderTextarea("methodology", "Metodología")}
            {this.renderTextarea("expected_results", "Resultados esperados")}
            {this.renderTextarea(
              "transference_results",
              "Transferencia de resultados"
            )}
            {this.renderTextarea("beneficiaries", "Beneficiarios")}
            {/*this.renderTextarea('impacts', 'Impactos bioéticos y sociales')*/}
            {/*this.renderTextarea('aspects', 'Aspectos')*/}

            <h4 style={{ color: "silver" }}>
              {" "}
              &nbsp; &nbsp; OTROS PRODUCTOS DE LA INVESTIGACIÓN:{" "}
            </h4>
            {this.renderTextarea("distinctive_signs", "Signos distintivos")}

            {this.renderSelect(
              "patents_id",
              "Patentes",
              145,
              "id",
              "name",
              patents
            )}

            {this.renderTextarea(
              "denomination_origin",
              "Autorización de uso de denominación de origen"
            )}
            {this.renderTextarea("register_powers", "Registro de poderes")}
            {this.renderTextarea(
              "companies_without_documents",
              "Registro de empresas extranjeras/inventor sin documento"
            )}

            {this.renderSelect(
              "copyright_id",
              "Derechos de autor",
              160,
              "id",
              "name",
              copyright
            )}

            {this.renderTextarea(
              "senadi",
              "Otros que el Servicio Nacional de Derechos Intelectuales SENADI definiera"
            )}
            <h4 style={{ color: "white" }}> HOLA </h4>
          </React.Fragment>
        );
      case 2:
        return <React.Fragment>3er Componente</React.Fragment>;
      case 3:
        return "Step 4: Presupuesto";
      default:
        return "Unknown step";
    }
  };
  schema = Joi.object({
    is_open: Joi.boolean().messages(messages),
    id: Joi.string().guid(),
    name: Joi.string().label("Nombre").max(5000).messages(messages),
    slug: Joi.string().label("Slug").max(5000).messages(messages),
    code: Joi.string().label("Código IDI").allow("").max(50).messages(messages),
    kind: Joi.string().label("Tipo").max(60).messages(messages),
    lines: Joi.array()
      .label("Líneas de investigación")
      .allow("")
      .messages(messages),

    dependencies: Joi.array()
      .label("Dependencias/Facultad/Sede")
      .min(1)
      .messages(messages),

    careers: Joi.array().label("Carreras").messages(messages),

    startDate: Joi.date().label("Fecha Inicio"),
    endDate: Joi.date().label("Fecha Fin"),

    endDateReal: Joi.date().allow("", null).label("Fecha Final - Prórroga"),

    year: Joi.number().positive().label("Año").min(2017).messages(messages),

    groups: Joi.array().label("Grupos").messages(messages),
    comites: Joi.array().label("Comite").messages(messages),

    sponsor: Joi.string()
      .label("Contraparte")
      .allow("")
      .max(5000)
      .messages(messages),

    location: Joi.string().label("Ubicación").max(3000).messages(messages),
    project_type_id: Joi.number()
      .integer()
      .less(3)
      .label("Tipo proyecto")
      .messages(messages),
    coverage_type_id: Joi.number()
      .integer()
      .less(7)
      .label("Tipo cobertura")
      .messages(messages),
    research_type_id: Joi.number()
      .integer()
      .less(4)
      .label("Tipo investigación")
      .messages(messages),
    programs: Joi.array().label("Programas").min(1).messages(messages),

    sectors: Joi.array().label("Sectores impacto").min(1).messages(messages),

    summary: Joi.string()
      .label("Resumen")
      .allow("")
      .max(10000)
      .messages(messages),
    background: Joi.string()
      .label("Antecedentes")
      .allow("")
      .max(10000)
      .messages(messages),
    justification: Joi.string()
      .label("Justificación")
      .allow("")
      .max(10000)
      .messages(messages),
    current_situation: Joi.string()
      .label("Análisis situación actual")
      .allow("")
      .max(10000)
      .messages(messages),
    general_objective: Joi.string()
      .label("Objetivo General")
      .allow("")
      .max(10000)
      .messages(messages),
    specific_objectives: Joi.string()
      .label("Objetivos específicos")
      .allow("")
      .max(10000)
      .messages(messages),
    sustainability: Joi.string()
      .label("Sostenibilidad")
      .allow("")
      .max(10000)
      .messages(messages),
    methodology: Joi.string()
      .label("Metodología")
      .allow("")
      .max(10000)
      .messages(messages),
    expected_results: Joi.string()
      .label("Resultados esperados")
      .allow("")
      .max(10000)
      .messages(messages),
    transference_results: Joi.string()
      .label("Transferencia de resultados")
      .allow("")
      .max(10000)
      .messages(messages),
    beneficiaries: Joi.string()
      .label("Beneficiarios")
      .allow("")
      .max(10000)
      .messages(messages),

    distinctive_signs: Joi.string()
      .label("Signos Distintivos")
      .allow("")
      .max(10000)
      .messages(messages),

    patents_id: Joi.number()
      .label("Patentes")
      .integer()
      .allow("", null)
      .optional()
      .messages(messages),

    denomination_origin: Joi.string()
      .label("Autorización de uso de denominación de origen")
      .allow("")
      .max(10000)
      .messages(messages),

    register_powers: Joi.string()
      .label("Registro de poderes")
      .allow("")
      .max(10000)
      .messages(messages),
    companies_without_documents: Joi.string()
      .label("Registro de empresas extranjeras/inventor sin documento")
      .allow("")
      .max(10000)
      .messages(messages),
    copyright_id: Joi.number()
      .label("Registro de Derechos de autor")
      .integer()
      .allow("", null)
      .optional()
      .less(7)
      .messages(messages),
    senadi: Joi.string()
      .label(
        "Otros que el Servicio Nacional de Derechos Intelectuales SENADI definiera"
      )
      .allow("")
      .max(10000)
      .messages(messages),
  });

  async populateProjectTypes() {
    const { data: projectTypes } = await getProjectTypes();
    this.setState({ projectTypes });
  }

  async populateResearchTypes() {
    const { data: researchTypes } = await getResearchTypes();
    this.setState({ researchTypes });
  }

  async populateCoverageTypes() {
    const { data: coverageTypes } = await getCoverageTypes();
    this.setState({ coverageTypes });
  }

  async populatePrograms() {
    const { data: programs } = await getPrograms();
    this.setState({ programs });
  }

  async populatePatents() {
    const { data: patents } = await getPatents();
    this.setState({ patents });
  }

  async populateGroups() {
    const { data: groups } = await getGroups();
    this.setState({ groups });
  }
  async populateComites() {
    const { data: comites } = await getComites();
    this.setState({ comites });
  }

  async populateCopyright() {
    const { data: copyright } = await getCopyright();
    this.setState({ copyright });
  }

  async populateLines() {
    const { data: lines } = await getLines();
    this.setState({ lines });
  }

  async populateDependencies() {
    const { kind } = this.state.data;
    let type;
    if (kind === "") return;
    if (kind === "Institucional") {
      type =
        kind === "Institucional"
          ? DEPENDENCIES_BY_TYPE.INSTITUTIONAL
          : DEPENDENCIES_BY_TYPE.INSTITUTIONAL;
    }
    if (kind === "Facultad") {
      type =
        kind === "Facultad"
          ? DEPENDENCIES_BY_TYPE.FACULTY
          : DEPENDENCIES_BY_TYPE.FACULTY;
    }
    if (kind === "Sede") {
      type =
        kind === "Sede"
          ? DEPENDENCIES_BY_TYPE.FACULTY_SEDE_ACADEMIC
          : DEPENDENCIES_BY_TYPE.FACULTY_SEDE_ACADEMIC;
    }
    const { data: dependencies } = await getDependenciesByType(type);
    this.setState({ dependencies });
  }

  async populateCareers() {
    //const faculty = this.data.dependencies;
    const { data: careers } = await getDependenciesByType(
      DEPENDENCIES_BY_TYPE.CAREER
    );
    this.setState({ careers });
  }

  async populateSectors() {
    const { data: sectors } = await getSectors();
    this.setState({ sectors });
  }

  async populateProject() {
    try {
      const projectSlug = this.props.projectSlug; //Pasando por URL id movie
      //const projectSlug = this.props.match.params.slug; //Pasando por URL id movie
      if (projectSlug === "new") return; //Si si
      const { data: project } = await getProject(projectSlug); //Si no.
      this.setState({ data: this.mapToViewModel(project) });
    } catch (ex) {
      //console.log(ex);
      this.errorMessage(ex);
      if (ex.response && ex.response.status === 404) {
        this.props.history.replace("/not-found");
      } else if (ex.response.status === 403)
        this.props.history.replace("/not-authorized");
    }
  }

  async componentDidMount() {
    this._isMounted = true;
    //this.getStepContent();
    this.setState({ isLoading: true });
    await this.populateProjectTypes();
    await this.populateResearchTypes();
    await this.populateCoverageTypes();
    await this.populatePatents();
    await this.populateGroups();
    await this.populateComites();
    await this.populateCopyright();
    await this.populatePrograms();
    await this.populateSectors();
    await this.populateLines();
    await this.populateDependencies();
    await this.populateCareers();
    await this.populateProject();
    if (this._isMounted) this.setState({ isLoading: false });
    this.setState({ isLoading: false });
  }

  async componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.state.data.kind !== prevState.data.kind) {
      await this.populateDependencies();
    }
  }

  mapToViewModel(project) {
    return {
      is_open: project.is_open === 0 ? false : true,
      id: project.id,
      name: project.name,
      slug: project.slug,
      code: project.code === null ? "" : project.code,
      kind: project.kind === null ? "" : project.kind,
      startDate: project.startDate === null ? "" : project.startDate,
      endDate: project.endDate === null ? "" : project.endDate,
      endDateReal: project.endDateReal === null ? "" : project.endDateReal,
      dependencies: project.dependencies,
      careers: project.careers,
      lines: project.lines,
      year: project.year,
      groups: project.groups,
      comites: project.comites,

      sponsor: project.sponsor === null ? "" : project.sponsor,
      location: project.location === null ? "" : project.location,
      project_type_id:
        project.project_type_id === null ? "" : project.project_type_id,
      research_type_id:
        project.research_type_id === null ? "" : project.research_type_id,
      coverage_type_id:
        project.coverage_type_id === null ? "" : project.coverage_type_id,
      programs: project.programs === null ? "" : project.programs,
      sectors: project.impact_sectors,

      summary: project.summary === null ? "" : project.summary,
      background: project.background === null ? "" : project.background,
      justification:
        project.justification === null ? "" : project.justification,
      current_situation:
        project.current_situation === null ? "" : project.current_situation,
      general_objective:
        project.general_objective === null ? "" : project.general_objective,
      specific_objectives:
        project.specific_objectives === null ? "" : project.specific_objectives,
      sustainability:
        project.sustainability === null ? "" : project.sustainability,
      methodology: project.methodology === null ? "" : project.methodology,
      expected_results:
        project.expected_results === null ? "" : project.expected_results,
      transference_results:
        project.transference_results === null
          ? ""
          : project.transference_results,
      beneficiaries:
        project.beneficiaries === null ? "" : project.beneficiaries,
      //impacts: project.impacts === null ? '' : project.impacts,
      //aspects: project.aspects === null ? '' : project.aspects,
      distinctive_signs:
        project.distinctive_signs === null ? "" : project.distinctive_signs,
      patents_id: project.patents_id === null ? "" : project.patents_id,
      denomination_origin:
        project.denomination_origin === null ? "" : project.denomination_origin,
      register_powers:
        project.register_powers === null ? "" : project.register_powers,
      companies_without_documents:
        project.companies_without_documents === null
          ? ""
          : project.companies_without_documents,
      copyright_id: project.copyright_id === null ? "" : project.copyright_id,
      senadi: project.senadi === null ? "" : project.senadi,
    };
  }

  handleChangeSlug(slug) {
    const data = { ...this.state.data };
    data.slug = slug;
    this.setState({ data });
  }

  handleChangeSwitch = async (event) => {
    const data = { ...this.state.data };
    data.is_open = event.target.checked;
    this.setState({ data });
    try {
      updateProject_isOpenField(this.state.data.slug);
      this.props.populateStatuses();
      this.successMessage();
    } catch (ex) {
      this.errorMessage(ex);
    }
  };
  doSubmit = async () => {
    try {
      this.props.populateStatuses();
      const res = await saveProject(this.state.data);
      this.handleChangeSlug(res.data.slug);
      this.successMessage();
      this.props.history.push(`/proyecto/${this.state.data.slug}`);
    } catch (ex) {
      console.log(ex);
      //this.errorMessage(ex);
    }
  };

  componentWillUnmount() {
    this._isMounted = false;
  }

  steps = this.getSteps();

  totalSteps = () => {
    return this.steps.length;
  };

  completedSteps = () => {
    return Object.keys(this.state.completed).length;
  };

  isLastStep = () => {
    return this.state.activeStep === this.totalSteps() - 1;
  };

  allStepsCompleted = () => {
    return this.completedSteps() === this.totalSteps();
  };

  handleNext = () => {
    const newActiveStep =
      this.isLastStep() && !this.allStepsCompleted()
        ? // It's the last step, but not all steps have been completed,
          // find the first step that has been completed
          this.steps.findIndex((step, i) => !(i in this.state.completed))
        : this.state.activeStep + 1;
    this.setState({ activeStep: newActiveStep });
  };

  handleBack = () => {
    //setActiveStep((prevActiveStep) => prevActiveStep - 1);
    this.setState({
      activeStep: this.state.activeStep - 1,
    });
  };

  handleStep = (step) => () => {
    this.setState({
      activeStep: step,
    });
  };

  handleComplete = () => {
    const newCompleted = this.state.completed;
    newCompleted[this.state.activeStep] = true;
    this.setState({ completed: newCompleted });
    this.handleNext();
  };

  handleReset = () => {
    this.setState({ activeStep: 0, completed: {} });
  };

  render() {
    const classes = {
      root: {
        width: "100%",
      },
      button: {
        marginRight: "1em",
      },
      completed: {
        display: "inline-block",
      },
      instructions: {
        marginTop: "1em",
        marginBottom: "1em",
      },
    };

    // let disabled = true;
    // if (this.validate() === null) disabled = false;

    return (
      <Paper className="paper" elevation={10}>
        {/* <Fab
          variant='extended'
          size='medium'
          color='secondary'
          aria-label='add'
          className='btn btn-send'
          disabled={disabled}
        >
          <NavigationIcon />
          Enviar
        </Fab> */}
        <Loading open={this.state.isLoading} />
        <TitleComponent entity={"PROYECTO"} />
        <form onSubmit={this.handleSubmit}>
          <div className={classes.root}>
            <Stepper
              nonLinear
              activeStep={this.state.activeStep}
              style={{ width: "35%" }}
            >
              {this.steps.map((label, index) => (
                <Step key={label}>
                  <StepButton
                    onClick={this.handleStep(index)}
                    completed={this.state.completed[index]}
                  >
                    {label}
                  </StepButton>
                </Step>
              ))}
            </Stepper>
            <div>
              {this.allStepsCompleted() ? (
                <div>
                  <Typography>
                    All steps completed - you&apos;re finished
                  </Typography>
                  <Button onClick={this.handleReset}>Reset</Button>
                </div>
              ) : (
                <div>
                  <div>
                    {this.getStepContent(
                      this.state.activeStep,
                      this.state.sectors
                    )}
                  </div>
                  <div>
                    <Button
                      variant={"outlined"}
                      disabled={this.state.activeStep === 0}
                      onClick={this.handleBack}
                      style={classes.button}
                    >
                      Atrás
                    </Button>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={this.handleNext}
                      style={classes.button}
                    >
                      Siguiente
                    </Button>
                    {this.state.activeStep !== this.steps.length &&
                      (this.state.completed[this.state.activeStep] ? (
                        <Typography variant="caption">
                          Step {this.state.activeStep + 1} already completed
                        </Typography>
                      ) : (
                        <Button
                          variant="contained"
                          type="submit"
                          color="primary"
                          style={classes.button}
                          startIcon={<SaveIcon />}
                        >
                          {this.completedSteps() === this.totalSteps() - 1
                            ? "Finalizar"
                            : "Guardar"}
                        </Button>
                      ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        </form>
      </Paper>
    );
  }
}

export default withSnackbar(ProjectForm);
